import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/axiosHub';
import moment from 'moment';

// Thunks
export const GetEmployees = createAsyncThunk('/GetEmployees', async () => {
    const response = await baseAxios.get(`Api/Payment/Employees`);
    return response.data;
});

export const GetStatuses = createAsyncThunk('/GetStatuses', async () => {
    const response = await baseAxios.get(`Api/Payment/Statuses`);
    return response.data;
});



export const CreatePaymentSession = createAsyncThunk(
    'payment/CreatePaymentSession',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Api/Payment/create-session', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const ProductPreSale = createAsyncThunk(
    'payment/ProductPreSale',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Api/Payment/ProductPreSale', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const WarrantyPreSales = createAsyncThunk(
    'payment/WarrantyPreSales',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await baseAxios.post('Api/Payment/WarrantyPreSales', paymentData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const SearchPayments = createAsyncThunk(
    'payment/SearchPayments',
    async (dto, { rejectWithValue }) => {
        try {
            // Query string oluşturuluyor
            const params = new URLSearchParams([
                ['EmployeeId', dto.EmployeeId],
                ['StatusId', dto.StatusId],
                ['CreateDate', moment(dto.CreateDate).format('YYYY-MM-DD')]
            ]);

            const response = await baseAxios.get(`Api/Payment/paymentData`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const ResendProcessPayment = createAsyncThunk(
    'payment/ResendProcessPayment',
    async (dto, { rejectWithValue }) => {
        try {
            await baseAxios.post('Api/Payment/resend', dto);
            return true; // Başarılı olursa true döndür
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const GetSironexActivatedTenants = createAsyncThunk('/GetSironexActivatedTenants', async () => {
    const response = await baseAxios.get(`Api/Payment/activatedTenants`);
    return response.data;
});

export const GetProductTenantSales = createAsyncThunk('/GetProductTenantSales', async () => {
    const response = await baseAxios.get(`Api/Payment/productTenantSales`);
    return response.data;
});
// WorkOrder doğrulama
export const VerifyWorkOrder = createAsyncThunk(
  '/VerifyWorkOrder',
  async (workOrderId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Api/Payment/verifyWorkOrder/${workOrderId}`);
      return response.data; // ResponseDto<VerifyWorkOrderDto>
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);
export const GetProductOrderList = createAsyncThunk(
  '/GetProductOrderList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Api/Payment/GetProductOrderList`);
      return response.data; // List<ProductOrderDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: CreateCustomer
export const CreateCustomer = createAsyncThunk(
  'payment/CreateCustomer',
  async (consumerDto, { rejectWithValue }) => {
    try {
      const response = await baseAxios.post('Api/Payment/CreateCustomer', consumerDto);
      return response.data; // ResponseDto<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: SearchConsumer (GET /payment/SearchConsumer/{consumerName})
export const SearchConsumer = createAsyncThunk(
  'payment/SearchConsumer',
  async (consumerName, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Api/Payment/SearchConsumer/${encodeURIComponent(consumerName)}`);
      return response.data; // List<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: CreateProductOrder (POST /payment/CreateProductOrder)
export const CreateProductOrder = createAsyncThunk(
  'payment/CreateProductOrder',
  async (dto, { rejectWithValue }) => {
    try {
      const response = await baseAxios.post('Api/Payment/CreateProductOrder', dto);
      return response.data; // int (created order id)
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// New: GetConsumerInfo (GET /payment/GetConsumerInfo/{consumerId})
export const GetConsumerInfo = createAsyncThunk(
  'payment/GetConsumerInfo',
  async (consumerId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Api/Payment/GetConsumerInfo/${consumerId}`);
      return response.data; // ResponseDto<ConsumerDto>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// New: GetEmployeePosMatching (GET /payment/GetEmployeePosMatching/{employeeId})
export const GetEmployeePosMatching = createAsyncThunk(
  'payment/GetEmployeePosMatching',
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await baseAxios.get(`Api/Payment/GetEmployeePosMatching/${employeeId}`);
      return response.data; // ResponseDto<List<EmployeePosMatchingDto>>
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const paymentSlice = createSlice({
    name: 'payment',
    initialState: {
        employeeList: [],
        selectedEmployee: null,
        statusList: [],
        selectedStatus: null,
        selectedCreateDate: moment()
            .startOf('day')
            .format('YYYY-MM-DD'),
        paymentSessionData: null,
        paymentUrl: null,
        paymentDataList: [],
        loading: 'idle',
        error: null,
        activatedTenants: [],
        productTenantSales: [],
        verifyWorkOrderLoading: 'idle',
        verifyWorkOrderData: null,
        verifyWorkOrderError: null,
        productName: '', 
        productSKU: '',
        productPrice: '',
        workOrderId: '',          // doğrulanan / girilen workOrder
        paymentInitiated: false, // Proceed butonuna basıldı mı
        productId: 0,           // eklenen ürün
        productOrderList: [],
        createdCustomer: null,
        createCustomerLoading: 'idle',
        createCustomerError: null,
        consumerSearchResults: [],
        consumerSearchLoading: 'idle',
        consumerSearchError: null,
        createdProductOrderId: null,
        createProductOrderLoading: 'idle',
        createProductOrderError: null,
        verifiedCustomerId: null,
        consumerInfoData: null,
        consumerInfoLoading: 'idle',
        consumerInfoError: null,
        employeePosMatching: [],
        employeePosMatchingLoading: 'idle',
        employeePosMatchingError: null,
        selectedPosDeviceId: null,
        cuiNumber: ''
    },
    reducers: {
        setSelectedEmployee: (state, action) => {
            state.selectedEmployee = action.payload;
        },
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        },
        setSelectedCreateDate: (state, action) => {
            state.selectedCreateDate = action.payload;
        },
        clearPaymentError: (state) => {
            state.error = null;
            // New: also clear create customer error
            state.createCustomerError = null;
        },
        clearPaymentData: (state) => {
            state.paymentSessionData = null;
            state.paymentUrl = null;
            state.error = null;
        },
        clearPaymentDataList: (state) => {
            state.paymentDataList = [];
            state.error = null;
        },
        clearVerifyWorkOrder: (state) => {
            state.verifyWorkOrderData = null;
            state.verifyWorkOrderError = null;
            state.verifyWorkOrderLoading = 'idle';
            // New: also clear verified customer id
            state.verifiedCustomerId = null;
        },
        setProductName: (state, action) => { state.productName = action.payload || ''; },
        setProductSKU: (state, action) => { state.productSKU = action.payload || ''; },
        setProductPrice: (state, action) => { state.productPrice = action.payload || ''; },

        setWorkOrderId: (state, action) => { state.workOrderId = action.payload || ''; },
        clearProductSelection: (state) => {
          state.productName = '';
          state.productSKU = '';
          state.productPrice = '';
          state.productId = 0;
        },
        setPaymentInitiated: (state, action) => {
          state.paymentInitiated = !!action.payload;
        },
        setProductId: (state, action) => { state.productId = action.payload || 0; },
        // New: clear created customer
        clearCreatedCustomer: (state) => {
          state.createdCustomer = null;
          state.createCustomerLoading = 'idle';
          state.createCustomerError = null;
        },
        // Optional: clear consumer search state
        clearConsumerSearch: (state) => {
          state.consumerSearchResults = [];
          state.consumerSearchLoading = 'idle';
          state.consumerSearchError = null;
        },
        // New: clear created product order
        clearCreatedProductOrder: (state) => {
          state.createdProductOrderId = null;
          state.createProductOrderLoading = 'idle';
          state.createProductOrderError = null;
        },
        clearConsumerInfo: (state) => {
          state.consumerInfoData = null;
          state.consumerInfoLoading = 'idle';
          state.consumerInfoError = null;
          state.cuiNumber = '';
        },
        // New: setter to persist selected consumer id
        setVerifiedCustomerId: (state, action) => {
          state.verifiedCustomerId = action.payload || null;
        },
        // New: clear employee pos matching
        clearEmployeePosMatching: (state) => {
          state.employeePosMatching = [];
          state.employeePosMatchingLoading = 'idle';
          state.employeePosMatchingError = null;
        },
        // New: setter to persist selected consumer id
        setVerifiedCustomerId: (state, action) => {
          state.verifiedCustomerId = action.payload || null;
        },
        // New: setter for selected POS device
        setSelectedPosDeviceId: (state, action) => {
          state.selectedPosDeviceId = action.payload || null;
        },
        // New: setter for CuiNumber
        setCuiNumber: (state, action) => {
          state.cuiNumber = action.payload || '';
        },
    },
    extraReducers: {
        [GetEmployees.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetEmployees.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetEmployees.fulfilled]: (state, action) => {
            state.employeeList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [GetStatuses.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetStatuses.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetStatuses.fulfilled]: (state, action) => {
            state.statusList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [CreatePaymentSession.pending]: (state) => {
            state.loading = 'Loading';
        },
        [CreatePaymentSession.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [CreatePaymentSession.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [WarrantyPreSales.pending]: (state) => {
            state.loading = 'Loading';
        },
        [WarrantyPreSales.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [WarrantyPreSales.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [SearchPayments.pending]: (state) => {
            state.loading = 'Loading';
        },
        [SearchPayments.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [SearchPayments.fulfilled]: (state, action) => {
            state.paymentDataList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [ResendProcessPayment.pending]: (state) => {
            state.loading = 'Loading';
        },
        [ResendProcessPayment.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [ResendProcessPayment.fulfilled]: (state) => {
            state.loading = 'Finished';
        },
        [GetSironexActivatedTenants.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetSironexActivatedTenants.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetSironexActivatedTenants.fulfilled]: (state, action) => {
            state.activatedTenants = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [GetProductTenantSales.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetProductTenantSales.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetProductTenantSales.fulfilled]: (state, action) => {
            state.productTenantSales = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        [VerifyWorkOrder.pending]: (state) => {
            state.verifyWorkOrderLoading = 'Loading';
            state.verifyWorkOrderError = null;
            state.verifyWorkOrderData = null;
        },
        [VerifyWorkOrder.rejected]: (state, action) => {
            state.verifyWorkOrderLoading = 'Finished';
            state.verifyWorkOrderError = action.payload;
        },
        [VerifyWorkOrder.fulfilled]: (state, action) => {
            state.verifyWorkOrderLoading = 'Finished';
            state.verifyWorkOrderData = action.payload;
            // New: extract CustomerId from response
            const ro = action.payload?.ResponseObject;
            state.verifiedCustomerId = (ro?.CustomerId ?? action.payload?.CustomerId ?? null) || null;
        },
        [ProductPreSale.pending]: (state) => {
            state.loading = 'Loading';
        },
        [ProductPreSale.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [ProductPreSale.fulfilled]: (state, action) => {
            state.paymentSessionData = action.payload;
            state.paymentUrl = action.payload.PaymentUrl;
            state.loading = 'Finished';
        },
        [GetProductOrderList.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetProductOrderList.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetProductOrderList.fulfilled]: (state, action) => {
            state.productOrderList = Array.isArray(action.payload) ? action.payload : [];
            state.loading = 'Finished';
        },
        // New: CreateCustomer handlers
        [CreateCustomer.pending]: (state) => {
          state.createCustomerLoading = 'Loading';
          state.createCustomerError = null;
          state.createdCustomer = null;
        },
        [CreateCustomer.rejected]: (state, action) => {
          state.createCustomerLoading = 'Finished';
          state.createCustomerError = action.payload;
        },
        [CreateCustomer.fulfilled]: (state, action) => {
          state.createCustomerLoading = 'Finished';
          state.createdCustomer = action.payload;
        },
        // New: SearchConsumer handlers
        [SearchConsumer.pending]: (state) => {
          state.consumerSearchLoading = 'Loading';
          state.consumerSearchError = null;
          state.consumerSearchResults = [];
        },
        [SearchConsumer.rejected]: (state, action) => {
          state.consumerSearchLoading = 'Finished';
          state.consumerSearchError = action.payload;
        },
        [SearchConsumer.fulfilled]: (state, action) => {
          state.consumerSearchLoading = 'Finished';
          state.consumerSearchResults = Array.isArray(action.payload) ? action.payload : [];
        },
        // New: CreateProductOrder handlers
        [CreateProductOrder.pending]: (state) => {
          state.createProductOrderLoading = 'Loading';
          state.createProductOrderError = null;
          state.createdProductOrderId = null;
        },
        [CreateProductOrder.rejected]: (state, action) => {
          state.createProductOrderLoading = 'Finished';
          state.createProductOrderError = action.payload;
        },
        [CreateProductOrder.fulfilled]: (state, action) => {
          state.createProductOrderLoading = 'Finished';
          state.createdProductOrderId = typeof action.payload === 'number' ? action.payload : null;
        },
        // New: GetConsumerInfo handlers
        [GetConsumerInfo.pending]: (state) => {
          state.consumerInfoLoading = 'Loading';
          state.consumerInfoError = null;
          state.consumerInfoData = null;
        },
        [GetConsumerInfo.rejected]: (state, action) => {
          state.consumerInfoLoading = 'Finished';
          state.consumerInfoError = action.payload;
        },
        [GetConsumerInfo.fulfilled]: (state, action) => {
          state.consumerInfoLoading = 'Finished';
          state.consumerInfoData = action.payload;
          // Extract CuiNumber from response
          const ro = action.payload?.ResponseObject;
          state.cuiNumber = ro?.CuiNumber || '';
        },
        // New: GetEmployeePosMatching handlers
        [GetEmployeePosMatching.pending]: (state) => {
          state.employeePosMatchingLoading = 'Loading';
          state.employeePosMatchingError = null;
          state.employeePosMatching = [];
        },
        [GetEmployeePosMatching.rejected]: (state, action) => {
          state.employeePosMatchingLoading = 'Finished';
          state.employeePosMatchingError = action.payload;
        },
        [GetEmployeePosMatching.fulfilled]: (state, action) => {
          state.employeePosMatchingLoading = 'Finished';
          // Extract ResponseObject if present, fallback to payload itself
          const data = action.payload?.ResponseObject || action.payload;
          state.employeePosMatching = Array.isArray(data) ? data : [];
        }
    }
});

export const paymentActions = paymentSlice.actions;
export const paymentThunks = {
    CreatePaymentSession,
    GetEmployees,
    GetStatuses,
    WarrantyPreSales,
    SearchPayments,
    ResendProcessPayment,
    GetSironexActivatedTenants,
    GetProductTenantSales,
    VerifyWorkOrder,
    ProductPreSale,
    GetProductOrderList,
    CreateCustomer,
    SearchConsumer,
    CreateProductOrder,
    GetConsumerInfo,
    GetEmployeePosMatching
};

export default paymentSlice.reducer;

